<template>
        <nav style="position: fixed">
        <a class="logo-img" href="#">
            <img :src="logoSrc">
        </a>
        <div class="work-name">
            <input placeholder="请输入作品名称" v-model="title">
        </div>
        <div class="work-save" @click="onSaveToLocal" >
            <div style="background:transparent">保存到电脑</div>
        </div>
         <div class="work-save"  >
            <div style="background:transparent;padding-left:0;padding-right:0"> | </div>
        </div>
        <div class="work-save"  style="position:relative">
            <div style="background:transparent">从电脑上传</div>
            <input v-if="fileVisibility" type="file" style="height:100%;width:100%;position:absolute;top:0;opacity: 0" @change="onChange"/>
        </div>
        <div class="work-save"  @click="onShowTask" v-if="taskVisibility">
            <div>提示</div>
        </div>
        <div class="work-save"  @click="onShowVideo" v-if="vedioVisibility">
            <div>教学视频</div>
        </div>
        <div class="work-save"  @click="onShowMind" v-if="mindVisibility">
            <div>思维导图</div>
        </div>
        <div class="work-save"  @click="onReload" v-if="info.bookSubId && info.role == 1 && info.isSb3 !=2">
            <div>重新开始</div>
        </div>
         <div class="work-save"  @click="onSaveJob" v-if="info.bookSubId && info.role == 1 && info.isSb3 !=2 || info.isJob">
            <div>保存作业</div>
        </div>
        <div class="work-save"  @click="onOpenProject" v-if="!info.bookSubId && info.role!=2 && info.token && !info.isExam">
            <div>保存作品</div>
        </div>
        <div class="time" v-if="bookSubInfo.id">{{time}}</div>
        <exam v-if="info.isExam" @handleGetSb3Url="handleGetSb3Url" @handleLoadProject="handleLoadProject"/>
    </nav>
  
</template>

<script>
import { mapState } from 'vuex'
import { info as bookSubInfo } from '@/api/book-sub.js'
import { info as taskInfo } from '@/api/book-task.js' 
import { info as jobInfo ,save as saveJob , saveTime ,getJobInfo, updateJob} from '@/api/job'
import { uploadFile } from '@/api/resouce'
import { dateFormat } from '@/utils/utils'
import {info as resultInfo , save as saveResult } from '@/api/result'
import { info as siteInfo } from '@/api/site'
import axios from 'axios'
import Exam from './Exam.vue'
  export default {
    name: 'menu-bar',
    components: {
        Exam
    },
    data(){
        return {
            logoSrc: require('../assets/logo.png'),
            bookSubInfo: {},
            taskVisibility: false,
            vedioVisibility:false,
            mindVisibility: false, 
            title: 'python作品',
            time: '00:00:00',   // 倒计时
            fileVisibility: true, // 从电脑选择文件上传，用来重置input 的 change 事件
            projectVisibility: false, // 是否显示保存作品的弹框
            resultInfo: {} // 作品相关
        }
    },

    computed:{
        ...mapState({
            info: state=> state.info
        })
    },
    created(){
        if(this.info.title){
            this.title = this.info.title
        }
        this.handleDomain()
        this.handleInitData()
        this.handleTime()
    },
    methods: {
     
        handleDomain(){
            console.log(this.info)
            if(this.info.domain){
                siteInfo(this.info.domain).then(res=>{
                    this.logoSrc = res.logo
                })
            }
           
        },
        // 打开保存作品的弹窗
        onOpenProject(){
                this.$emit('saveProjec',this.title)
        },
        // 保存作品
        handleSaveProject(data){
              this.handleGetSb3Url(data.name).then(sb3=>{
                  data.sb3 = sb3
                  data.photo = 'https://s.mamale.vip/2020/09/22/21b9d37247a249e8fb5839f7c760deb5.jpeg'
                  data.type = 1
                  data.status = 1
                   if(this.info.resultId){
                       data.id = this.info.resultId
                   } 
                  saveResult(data).then(res=>{
                       this.info.resultId = res.id
                       this.$message({
                            message: '恭喜你，保存作品成功！',
                            type: 'success'
                        });
                  })
              })
        },
        handleLoadResult(){
            if(this.info.resultId){
                resultInfo(this.info.resultId).then(info=>{
                    this.title = info.name
                    this.$emit('updateForm',{name:this.title,content:info.content,information:info.information})
                })
            }
        },
        // 保存作业
        onSaveJob(){
            this.handleGetSb3Url(this.bookSubInfo.name).then(url=>{
                    const postData ={
                        name: this.bookSubInfo.name,
                        sb3: url,
                        photo: 'https://s.mamale.vip/2020/09/22/21b9d37247a249e8fb5839f7c760deb5.jpeg',
                        bookSubId: this.info.bookSubId,
                        classId: this.info.classId,
                        type: 1
                    }
                    const saveApi = this.info.isJob? updateJob: saveJob
                    saveApi(postData,this.info.jobId).then(res=>{
                        this.$message({
                            message: '恭喜你，保存作业成功！',
                            type: 'success'
                        });
                        this.saveTime()
                    })
            })
        },
        // 获取作品地址
        handleGetSb3Url(title,callback){

            return new Promise(resolve=>{
                this.$emit('getData',content => {
                    const blob = new Blob([content], {type: 'text/x-python'});
                    const Ob  = window.File ? window.File : Object
                    const file = new Ob([blob], title+ '.py', {type: 'text/x-python', lastModified: Date.now()});
                    uploadFile(file).then(({url})=>{
                        resolve(url)                
                        if(callback){
                            callback(url)
                        }        
                    })
                })
            })
        },
       
        saveTime(){
                const data = {
                    bookSubId: this.info.bookSubId,
                    classId: this.info.classId,
                    beginTime: dateFormat(new Date(this.info.startTime)),
                    endTime: dateFormat(new Date())
                }
                this.info.startTime= new Date().getTime()
                saveTime(data)
            },
        onChange(e){
            const that = this
            const docObj = e.target
            if (docObj.files && docObj.files[0]) {
                var reader = new FileReader();
                reader.readAsText(docObj.files[0],'utf-8');//发起异步请求
                reader.onload = function(){
                    //读取完成后，数据保存在对象的result属性中
                    that.$emit('loadPy',this.result)
                    that.fileVisibility = false
                    that.$nextTick(()=>{
                        that.fileVisibility = true
                    })
                }
            }
        },
        onSaveToLocal(){
            this.$emit('saveToLocal',this.title)
        },
        onShowMind(){
            this.$emit('showMind')
        },
        onShowTask(){
            this.$emit('showTask')
        },
        onShowVideo(){
            this.$emit('showVideo')
        },
        handleTime(){
             this.timer = setInterval(() => { let time = new Date().getTime()
                    let startTime = this.info.startTime
                    let diffTime = parseInt((time - startTime) / 1000)
                    let s = parseInt(diffTime % 60) < 10 ? '0' + parseInt(diffTime % 60) : parseInt(diffTime % 60)
                    let m = parseInt(diffTime / 60 % 60) < 10 ? '0' + parseInt(diffTime / 60 % 60) : parseInt(diffTime / 60 % 60)
                    let h = parseInt(diffTime / 60 / 60 % 60) < 10 ? '0' + parseInt(diffTime / 60 / 60 % 60) : parseInt(diffTime / 60 / 60 % 60)
                    this.time =  `${h}:${m}:${s}`
            }, 1000)
        },
        handleInitData(){
            //  如果有小节id， 那么
            if(this.info.bookSubId){
                // 如果有小节ID， 那么请求小节数组
                bookSubInfo(this.info.bookSubId).then(res=>{
                    console.log('小节信息',res)
                    this.bookSubInfo = res
                    this.$emit('setBookSubInfo',res)
                    this.handleBookInfo()
                    this.title = res.name
                })
                taskInfo(this.info.bookSubId).then(res=>{
                    this.$emit('setTaskList',res.items)
                     if(this.info.isTask){
                            this.onShowTask()
                    }
                    console.log('任务提示清单',res)
                    if(res.items.length> 0){
                        this.taskVisibility = true
                    }
                })
            }
            // 如果是直接加载sb3,那么就直接加载
            if(this.info.sb3){
                 this.handleLoadProject(this.info.sb3)   
            }
            // 如果是思维导图，加载思维导图
            if(this.info.isMind){
                this.onShowMind()
            }
            // 如果是学生，并且有小节id.需要判断下是否有思维导图
            if(this.info.role == 1 && this.info.bookSubId){
                // 如果是学生，需要判断下是否有思维导图
                // 需要判断是有思维导图
                axios(`https://api.mamale.vip/api/app/bookSub/${this.info.bookSubId}/mind`).then(res=>{
                    if(res.mind){
                        this.mindVisibility = true
                    }
                })
            }
            // 如果有作品，加载作品
            if(this.info.resultId){
                this.handleLoadResult()
            }
        },
        // 处理获取到小节后的各种业务逻辑请求
        handleBookInfo(){
            if(this.info.isMp4){
                this.onShowVideo()
            }
            if(this.bookSubInfo.mp4){
                this.vedioVisibility = true
            }

            if(this.info.role == 1 && this.info.isSb3 !=2){
                // 加载作业
                this.handleLoadJob()
            }else{
                // 加载源码
                if(this.info.isSb3){
                    this.handleLoadProject(this.info.isSb3==2?this.bookSubInfo.sb3Answer: this.bookSubInfo.sb3)
                }
            }
        },
        // 加载作品
        handleLoadProject(url){
             if(!url) return
              axios.get(url).then( res=> {
                    this.$emit('loadPy',res.data)
                }).catch(function(error){
                    console.log(error);
                });
        },
        // 加载作业
        handleLoadJob(){
            if(this.info.isJob){
                getJobInfo(this.info.jobId).then(res =>{
                     if(res.classId){
                         this.$store.commit('info/setClassId',res.classId)
                     }
                     if(res.class){
                         this.$store.commit('info/setClassId',res.class.id)
                     }
                    if(res && res.sb3){
                        this.handleLoadProject(res.sb3)
                    }else{
                        this.handleLoadProject(this.bookSubInfo.sb3)
                    }
                })
                return
            }
            jobInfo(this.info.classId,this.info.bookSubId).then(res=>{
                console.log('作业信息')
                console.dir(res)
                if(res && res.sb3){
                    this.handleLoadProject(res.sb3)
                }else{
                    this.handleLoadProject(this.bookSubInfo.sb3)

                }
            })
        },
        // 重新开始 -> 加载 小节的 sb3
        onReload(){
            this.handleLoadProject(this.bookSubInfo.sb3)      
        }
    }
  }
</script>

<style scoped>
    nav {
        width: 100%;
        height: 48px;
        background-color: #4D97FE;
    }

    .logo-img > img {
        height: 24px;
        margin-top: 12px;
        margin-left: 15px;
    }

    .work-name {
        display: inline-block;
        vertical-align: top;
        height: 28px;
        width: 200px;
        margin-top: 9px;
        margin-left: 25px;
    }

    .work-name > input {
        margin: auto;
        height: 26px;
        width: 180px;
        background-color: #428AEF;
        border-radius: 6px;
        border: 1px solid #207fc0;
        outline: none;
        padding-left: 10px;
        color: rgb(245, 245, 245);
        cursor: pointer;
    }

    .work-name > input::-webkit-input-placeholder {
        color: rgb(245, 245, 245);
    }

    .work-save {
        height: 100%;
        /* width: 80px; */
        display: inline-block;
        color: white;
        /*font-weight: 600;*/
        font-size: 12px;
        vertical-align: top;
        margin-left: 10px;
    }

    .work-save > div {
        padding: 0 10px;
        height: 28px;
        background-color: #FF8C1A;
        border-radius: 5px;
        text-align: center;
        line-height: 28px;
        margin-top: 10px;
        cursor: pointer;
        
    }
    .time{
        background: red;
        color: white;
        padding: 5px 10px;
        position: absolute;
        right: 300px;
        top: 8px;
        border-radius: 5px;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue